export const UNISWAP_ICON_URL =
  'https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/ethereum/assets/0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984/logo.png';

/** Flaunch market page for the TAKEOVER coin on Base (footer / promos). */
export const TAKEOVER_FLAUNCH_COIN_URL =
  'https://flaunch.gg/base/coins/0x716F8E756f9277F8c9949926141C2666B86B5809';

export const ADAPTER_ICON_URLS = {
  'uniswap-v3': UNISWAP_ICON_URL,
  'uniswap-v4': UNISWAP_ICON_URL,
  flaunch: '/flaunch-icon.png',
  aerodrome: '/aero-icon.png',
} as const;

export const ADAPTER_DISPLAY_LABELS = {
  'uniswap-v3': 'Uniswap V3',
  'uniswap-v4': 'Uniswap V4',
  flaunch: 'Flaunch',
  aerodrome: 'Aerodrome',
} as const;

export const PLATFORM_ICON_URLS = {
  uniswap: UNISWAP_ICON_URL,
  pancakeswap: '/cake-icon.svg',
  ...ADAPTER_ICON_URLS,
} as const;
